import React from 'react';
import Country from '../../../models/Country';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, darken } from  '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../../theme/ThemeContext';

export interface Row {
  data: Country
  action?: 'create' | 'update' | 'error';
}


interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  onClickInfo?: (country: Country) => void;
  onChangePage?: (page: number) => void;
}

const Countries: React.FC<Props> = (props) => {  
  const { t } = useTranslation('others')
  const { theme } = useThemeContext()

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  return (
      <Paper style={{borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px"}}>
      <ISTableTitle title={t('countries')}/>
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell>{t('intlCode')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('description')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('language')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('currentPriceListId')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('surplusPrepaymentCode')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('surplusPrepaymentQty')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('active')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { !props.loading && props.rows.map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{cursor: 'pointer', backgroundColor: !row.data.active ? darken(theme.palette.action.hover, 0.1) : ''}}
            onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
              <TableCell>{row.data.intlCode}</TableCell>
              <TableCell>{row.data.description}</TableCell>
              <TableCell>{row.data.language}</TableCell>
              <TableCell align='center'>{row.data.currentPriceListId}</TableCell>
              <TableCell align='center'>{row.data.surplusPrepaymentCode}</TableCell>
              <TableCell align='center'>{row.data.surplusPrepaymentQty}</TableCell>
              <TableCell>{row.data.active ? t('yes') : t('no')}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div style={{display:'flex', justifyContent:'center'}}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default Countries

